export const APP_LOGO_HEIGHT = 40;
export const APP_LOGO_WIDTH = 96;
export const APP_LOGO_HEIGHT_MEDIUM = 48;

/** The logo's width at `height`, keeping its native aspect ratio. */
export const getAppLogoWidth = (height: number) =>
    Math.round((height * APP_LOGO_WIDTH) / APP_LOGO_HEIGHT);
